import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Theme from '@root/brand/src/utils/theme';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function RadioInputGroup({ label, children }) {
  return (
    <fieldset css={styles.inputGroupWrapper}>
      {label && <legend css={styles.label}>{label}</legend>}
      {children}
    </fieldset>
  );
}

RadioInputGroup.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
};

const styles = StyleSheet.create({
  inputGroupWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    ...Theme.heading1(),
    marginBottom: 24,
  },
});
